export default {
    data() {
        return {
            progressTotal: 0,
            btn: false,
            uuId: "",
            partList: [],
            identifier: "",
            totalSize: "",
            url: "",
            fileName: ""
        }
    },
    filters: {
        btnText(btn) {
            return btn ? "继续" : "暂停";
        },
    },
    methods: {
        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                    v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        async handleBefore(file) {
            this.progressTotal = 1

            // 获取UUid唯一标识
            let uuId = this.guid()
            this.uuId = uuId;

            // 创建n个切片和每个切片参数
            let partList = [],
                partnum = file.size > 1 * 1024 * 1024 ? Math.ceil(file.size / (1 * 1024 * 1024)) : 1,
                partsize = Math.ceil(file.size / partnum),
                cur = 0;
            for (let i = 0; i < partnum; i++) {
                let item = {
                    chunkNumber: i + 1, // 当前文件块
                    chunkSize: partsize, //分块大小
                    currentChunkSize: file.slice(cur, cur + partsize).size, // 当前分块大小
                    totalSize: file.size, // 总大小
                    identifier: `${uuId}.pdf`, // 文件标识
                    filename: file.name, // 文件名
                    relativePath: file.name, // 相对路径
                    totalChunks: partnum, // 总块数
                    file: file.slice(cur, cur + partsize), // 切割文件
                };
                cur += partsize;
                partList.push(item);
            }

            this.partList = partList;
            this.fileName = file.name
            this.totalSize = file.size;
            this.sendRequest();


            // 让iView的upLoad组件阻止默认上传
            return new Promise((resolve, reject) => {
                reject(new Error('err'))
            })
        },
        async sendRequest() {
            // 根据n个切片创造n个请求（集合）
            let requestList = [];
            this.partList.forEach((item, index) => {
                // 每一个函数都是发送一个切片的请求
                let fn = () => {
                    let param = new FormData();
                    param.append("chunkNumber", item.chunkNumber);
                    param.append("chunkSize", item.chunkSize);
                    param.append("currentChunkSize", item.currentChunkSize);
                    param.append("totalSize", item.totalSize);
                    param.append("identifier", item.identifier);
                    param.append("filename", item.filename);
                    param.append("relativePath", item.relativePath);
                    param.append("totalChunks", item.totalChunks);
                    param.append("file", item.file);

                    return this.$apis.userServe.uplodeChunk(param).then((res) => {
                        if (res.resultCode === '200') {
                            this.progressTotal += Math.floor(99 / item.totalChunks);
                            // 传完的切片我们把它移除掉
                            this.partList.splice(index, 1);
                        }
                    })
                };
                requestList.push(fn);
            });
            // 传递：并行(ajax.abort())/串行(基于标志控制不发送)
            let i = 0;
            let complete = async () => {
                let res = await this.$apis.userServe.uplodeMergeFile({
                    filename: this.fileName,
                    identifier: `${this.uuId}.pdf`,
                    totalSize: this.totalSize,
                })
                if (res.resultCode === '200') {
                    this.checkMerge()
                } else {
                    // 上传合并文件失败
                    this.$Message.error('上传失败,请重新上传')
                    // 上传合并文件失败回显置空
                    this.url = null
                    this.fileName = ""
                }
            };
            let send = async () => {
                // 已经中断则不再上传
                if (this.abort) return;
                if (i >= requestList.length) {
                    // 分片都已经传完
                    this.progressTotal = 99
                    // 判断是否都已经上传完成
                    let isOver = true
                    for (let index = 0; index < requestList.length; index++) {
                        let res = await this.$apis.userServe.uplodeIsChunk({
                            identifier: `${this.uuId}.pdf`,
                            ChunkNumber: index + 1,
                        })
                        if (res.resultCode !== '200') {
                            isOver = false
                        }
                    }
                    // 都传完了
                    if (isOver) complete();
                    return;
                }
                await requestList[i]();
                i++;
                send();
            };
            send();
        },
        checkMerge() {
            setTimeout(async () => {
                let res = await this.$apis.userServe.uplodeCheckMerge({
                    identifier: `${this.uuId}.pdf`,
                })
                if (res.resultCode === '200') {
                    if (res.data) {
                        this.progressTotal = 100
                        this.url = res.data
                        this.$Message.success('文件上传成功')
                    } else {
                        this.checkMerge()
                    }
                } else {
                    this.$Message.error('上传失败,请重新上传')
                }
            }, 1500);
        },
        handleBtn() {
            if (this.btn) {
                //断点续传
                this.abort = false;
                this.btn = false;
                this.sendRequest();
                return;
            }
            //暂停上传
            this.btn = true;
            this.abort = true;
            this.$Message.warning('已暂停上传')
        },
    }
}